<script lang="ts">
    import { twMerge } from "tailwind-merge";
    import type { HTMLAttributes } from "svelte/elements";

    let {children, class: clazz = '', onClick, style, ...other}: {
        children: () => any,
        class?: HTMLAttributes<any>["class"],
        style?: HTMLAttributes<any>["style"],
        onClick?: () => any,
    } = $props();

    if (clazz == null || clazz == undefined) clazz = "";

    let className = twMerge("text-gray-700 black:text-white frappe:text-ctp-mauve cursor-default", clazz.toString());
</script>

<button {...other} style={style} onclick={onClick} class={className}>
    {@render children()}
</button>
